export enum EOrgAdjustFreight {
  autorizacionPorcentajeDescuentoMaximoFlete = 'AutorizacionPorcentajeDescuentoMaximoFlete',
  ajustemontofletenivel1 = 'ajustemontofletenivel1',
  ajustemontofletenivel2 = 'ajustemontofletenivel2',
}
